export default {
  gameColor: '#000000',
  futureBet: false,
  systemBet: false,
  additionalBetslipConfig: true,
  betslipConfiguration: {},
  adapters: [
    {
      name: 'GcmAdapter',
      type: 'Product',
      channels: [],
    },
  ],
  bettingType: 'draw',
  ticketType: 'ngsTicket',
  bettingPreview: 'BettingPreviewKeno',
  bettingInputs: [
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      betId: 0, // from config/bets ID
      clientId: 0,
      betType: 'normal', // standard, bet type
      betDisplayName: 'standard', // displayName, from config/bets name
      shortcut: '+',
      inputType: 'text',
      inputFields: 8,
      additionalInputs: ['future'],
      bettingPreview: {
        paytableOdds: true,
      },
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 80,
        },
        {
          type: 'pattern',
          expression: /^[1-9]\d?$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          max: 8,
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      betId: 0, // from config/bets ID
      clientId: 1,
      betType: 'system', // standard, bet type
      betDisplayName: 'standard', // displayName, from config/bets name
      shortcut: 's',
      inputType: 'text',
      inputFields: 8,
      additionalInputs: ['future', 'system'],
      bettingPreview: {
        paytableOdds: true,
      },
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 80,
        },
        {
          type: 'pattern',
          expression: /^[1-9]\d?$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          max: 8,
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 1,
      clientId: 2,
      betType: 'normal',
      betDisplayName: 'random',
      shortcut: 'r',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      bettingPreview: {
        paytableOdds: true,
      },
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 10,
        },
        {
          type: 'pattern',
          expression: /^[1-9]\d?$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 1,
      clientId: 3,
      betType: 'system',
      betDisplayName: 'random_system',
      shortcut: 'w',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future', 'system'],
      bettingPreview: {
        paytableOdds: true,
      },
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 10,
        },
        {
          type: 'pattern',
          expression: /^[1-9]\d?$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 30,
      clientId: 4,
      betType: 'special',
      betDisplayName: 'first_number_under_over',
      limit: 40.5,
      outcomes: ['under', 'over'],
      shortcut: 'c',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 1,
        },
        {
          type: 'range',
          min: 1,
          max: 2,
        },
        {
          type: 'pattern',
          expression: /^[1,2]$/,
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 31,
      clientId: 5,
      betType: 'special',
      betDisplayName: 'last_number_under_over',
      limit: 40.5,
      outcomes: ['under', 'over'],
      shortcut: 'v',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 1,
        },
        {
          type: 'range',
          min: 1,
          max: 2,
        },
        {
          type: 'pattern',
          expression: /^[1,2]$/,
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 32,
      clientId: 6,
      betType: 'special',
      betDisplayName: 'first_number_single_digit',
      outcomes: ['yes', 'no'],
      shortcut: 'k',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 1,
        },
        {
          type: 'range',
          min: 1,
          max: 2,
        },
        {
          type: 'pattern',
          expression: /^[1,2]$/,
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 33,
      clientId: 7,
      betType: 'special',
      betDisplayName: 'last_number_single_digit',
      outcomes: ['yes', 'no'],
      shortcut: 'l',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 1,
        },
        {
          type: 'range',
          min: 1,
          max: 2,
        },
        {
          type: 'pattern',
          expression: /^[1,2]$/,
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 34,
      clientId: 8,
      betType: 'special',
      betDisplayName: 'first_number_odd_even',
      outcomes: ['odd', 'even'],
      shortcut: 'h',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 1,
        },
        {
          type: 'range',
          min: 1,
          max: 2,
        },
        {
          type: 'pattern',
          expression: /^[1,2]$/,
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 35,
      clientId: 9,
      betType: 'special',
      betDisplayName: 'last_number_odd_even',
      outcomes: ['odd', 'even'],
      shortcut: 'j',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 1,
        },
        {
          type: 'range',
          min: 1,
          max: 2,
        },
        {
          type: 'pattern',
          expression: /^[1,2]$/,
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 36,
      clientId: 10,
      betType: 'special',
      betDisplayName: 'first_number_range',
      outcomes: ['1 - 20', '21 - 40', '41 - 60', '61 - 80'],
      shortcut: 'b',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
        {
          outcome: 3,
          shortcut: '3',
        },
        {
          outcome: 4,
          shortcut: '4',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 1,
        },
        {
          type: 'range',
          min: 1,
          max: 4,
        },
        {
          type: 'pattern',
          expression: /^[1-4][0-4]?$/,
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 37,
      clientId: 11,
      betType: 'special',
      betDisplayName: 'last_number_range',
      outcomes: ['1 - 20', '21 - 40', '41 - 60', '61 - 80'],
      shortcut: 'n',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
        {
          outcome: 3,
          shortcut: '3',
        },
        {
          outcome: 4,
          shortcut: '4',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 1,
        },
        {
          type: 'range',
          min: 1,
          max: 4,
        },
        {
          type: 'pattern',
          expression: /^[1-4][0-4]?$/,
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 38,
      clientId: 12,
      betType: 'special',
      betDisplayName: 'first_five_numbers_under_over',
      limit: 202.5,
      outcomes: ['under', 'over'],
      shortcut: 'o',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 1,
        },
        {
          type: 'range',
          min: 1,
          max: 2,
        },
        {
          type: 'pattern',
          expression: /^[1,2]$/,
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 39,
      clientId: 13,
      betType: 'special',
      betDisplayName: 'total_under_over',
      limit: 810.5,
      outcomes: ['under', 'over'],
      shortcut: 'p',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 1,
        },
        {
          type: 'range',
          min: 1,
          max: 2,
        },
        {
          type: 'pattern',
          expression: /^[1,2]$/,
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 40,
      clientId: 14,
      betDisplayName: 'no_draw',
      shortcut: 'u',
      inputType: 'text',
      inputFields: 20,
      additionalInputs: ['future'],
      bettingPreview: {
        paytableOdds: true,
      },
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 80,
        },
        {
          type: 'pattern',
          expression: /^[1-9]\d?$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 41,
      clientId: 15,
      betDisplayName: 'all_in',
      shortcut: 'i',
      inputType: 'text',
      inputFields: 6,
      additionalInputs: ['future'],
      bettingPreview: {
        paytableOdds: true,
      },
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 80,
        },
        {
          type: 'pattern',
          expression: /^[1-9]\d?$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
  ],
  additionalBettingInputs: [
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      label: 'future_bet',
      clientId: 'future',
      enabled: true,
      betType: 'future', // standard, bet type
      betDisplayName: 'future_bet', // displayName, from config/bets name
      shortcut: 'f',
      inputType: 'text',
      inputFields: 1,
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 10,
        },
        {
          type: 'pattern',
          expression: /^[1-9]$|^10$/, // only numbers, must be integer
        },
      ],
      betValidations: [],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
        {
          name: 'blur',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      label: 'system',
      clientId: 'system',
      enabled: true,
      systemMarket: true, // To distinct from premier rs input
      betType: 'system',
      betDisplayName: 'system',
      shortcut: null,
      inputType: 'text',
      inputFields: 1,
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 0,
          max: 0,
        },
        {
          type: 'pattern',
          expression: /^[1-9]$|^1[0-4]$/, // allows integers from 1 to 14
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
        {
          name: 'blur',
          handler: {},
        },
      ],
    },
  ],
  shortcuts: {
    '+': {
      id: 0, // bettingInput.clientId
      action: 'ticket',
      active: true,
      name: 'new_ticket',
      shortcut: '+',
      order: 1,
    },
    s: {
      id: 1,
      action: 'system',
      active: true,
      name: 'system',
      shortcut: 's',
      order: 2,
    },
    '/': {
      action: 'resetTicket',
      active: true,
      name: 'reset_ticket',
      shortcut: '/',
      order: 2,
    },
    q: {
      action: 'results',
      active: true,
      name: 'results',
      shortcut: 'q',
      order: 3,
    },
    'ctrl + m': {
      action: 'focusFirstBet',
      active: true,
      name: 'focus_first_bet',
      shortcut: 'ctrl + m',
      order: 4,
    },
    'ctrl + s': {
      action: 'editStakePerBet',
      active: true,
      name: 'edit_stake_per_bet',
      shortcut: 'ctrl + s',
      order: 5,
    },
    'ctrl + f': {
      action: 'editFuturePerTicket',
      active: true,
      name: 'edit_future_per_ticket',
      shortcut: 'ctrl + f',
      order: 6,
    },
    'ctrl + b': {
      action: 'focusFirstInput',
      active: true,
      name: 'focus_first_input',
      shortcut: 'ctrl + b',
      order: 7,
    },
    'ctrl + e': {
      action: 'toggleEditMode',
      active: false,
      name: 'toggle_delete_bet_mode',
      shortcut: 'ctrl + e',
      order: 8,
    },
    r: {
      id: 2,
      action: 'random',
      active: true,
      name: 'random',
      shortcut: 'r',
      order: 10,
    },
    w: {
      id: 3,
      action: 'randomSystem',
      active: true,
      name: 'random_system',
      shortcut: 'w',
      order: 13,
    },
    c: {
      id: 4,
      action: 'firstNumberUnderOver',
      active: true,
      name: 'first_number_under_over',
      shortcut: 'c',
      order: 17,
    },
    v: {
      id: 5,
      action: 'lastNumberUnderOver',
      active: true,
      name: 'last_number_under_over',
      shortcut: 'v',
      order: 17,
    },
    k: {
      id: 6,
      action: 'firstNumberSingleDigit',
      active: true,
      name: 'first_number_single_digit',
      shortcut: 'k',
      order: 17,
    },
    l: {
      id: 7,
      action: 'lastNumberSingleDigit',
      active: true,
      name: 'last_number_single_digit',
      shortcut: 'l',
      order: 17,
    },
    h: {
      id: 8,
      action: 'firstNumberOddEven',
      active: true,
      name: 'first_number_odd_even',
      shortcut: 'h',
      order: 17,
    },
    j: {
      id: 9,
      action: 'lastNumberOddEven',
      active: true,
      name: 'last_number_odd_even',
      shortcut: 'j',
      order: 17,
    },
    b: {
      id: 10,
      action: 'firstNumberRange',
      active: true,
      name: 'first_number_range',
      shortcut: 'b',
      order: 17,
    },
    n: {
      id: 11,
      action: 'lastNumberRange',
      active: true,
      name: 'last_number_range',
      shortcut: 'n',
      order: 17,
    },
    o: {
      id: 12,
      action: 'firstFiveNumberUnderOver',
      active: true,
      name: 'first_five_numbers_under_over',
      shortcut: 'o',
      order: 17,
    },
    p: {
      id: 13,
      action: 'totalUnderOver',
      active: true,
      name: 'total_under_over',
      shortcut: 'p',
      order: 17,
    },
    u: {
      id: 13,
      action: 'noDraw',
      active: true,
      name: 'no_draw',
      shortcut: 'u',
      order: 17,
    },
    i: {
      id: 13,
      action: 'allIn',
      active: true,
      name: 'all_in',
      shortcut: 'i',
      order: 17,
    },
    delete: {
      action: 'deleteBet',
      active: false,
      name: 'delete_bet',
      shortcut: 'delete',
      order: 9,
    },
    m: {
      action: 'quickBetslipMode',
      active: false,
      name: 'enable_quick_betslip_mode',
      shortcut: 'm',
      order: 22,
    },
    f: {
      id: 'future',
      action: 'future',
      active: true,
      name: 'future_bet',
      shortcut: 'f',
      order: 21,
    },
  },
  availableTicketActions: [
    {
      status: 'accepted',
      action: ['rebet', 'check', 'copy'],
    },
    {
      status: 'canceled',
      action: ['rebet'],
    },
    {
      status: 'paidout',
      action: ['rebet'],
    },
    {
      status: 'pending',
      action: ['checkStatus'],
    },
    {
      status: 'unknown',
      action: ['checkStatus'],
    },
    {
      status: 'failed',
      action: ['checkStatus'],
    },
    // 7Shop sets this local status, it should be paidout. This will be fixed in the future
    {
      status: 'payedout',
      action: ['rebet'],
    },
  ],
  actionTypes: {
    add: 'TicketPayIn',
    payout: 'TicketPayout',
    cancel: 'TicketCancel',
    copy: 'TicketCopy',
  },
  printLayoutType: {
    add: 'ticketKeno',
    payout: 'ticketKenoPayout',
    cancel: 'ticketCancel',
    results: 'resultsKeno',
  },
};
